import { PET_INSURANCE_APIS } from "@/api_framework/api_config";
import { IPetInsuranceFormData, IPetInsuranceFormsListResponse } from "@/api_framework/api_modals/PetInsurance";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const usePetInsuranceFormsListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (userId: string): Promise<IPetInsuranceFormData[]> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: AxiosResponse<IPetInsuranceFormsListResponse> = await axios.get(
        PET_INSURANCE_APIS?.FORMS_LIST?.baseURL ?? "",
        {
          params: { user_id: userId },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data.status === true) {
        return response.data.data?.forms ?? [];
      }
      return [];
    } catch (error) {
      const axiosError = error as AxiosError;
      captureError(axiosError);
      sendCurl((axiosError.config as any)?.curlCommand);
      return [];
    }
  }, [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl]);

  return execute;
};
